import React, { useContext, useEffect } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { CartContext } from "contexts/";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import Link from "next/link";
// import { getCartSubTotal } from "utils/helpers";
import Price from "components/Price";
import { colors } from "utils/styles";
import { UserContext } from "contexts/";

import QuantityInput from "./QuantityInput";
import Media from "components/Reusables/Media";
import Text from "components/Reusables/Text";
import Title from "components/Reusables/Title";
import { calcMemberPrice } from "utils/helpers";
import GTM from "@utils/GTM";
//container for product info
const ProductCol = (props) => {
	return (
		<Col xs={true} sm={5} className="justify-content-center d-flex align-items-center ">
			{props.children}
		</Col>
	);
};

//container for line item controls
const CenteredCol = (props) => {
	const align = props.align || "center";
	return (
		<Col xs={props.xs || 2} sm={props.sm || true} className={`justify-content-${align} d-flex align-items-center`}>
			{props.children}
		</Col>
	);
};

export default function CartTable(props) {
	const { localCart, setLocalCart, cartItems } = useContext(CartContext);
	const { userData } = useContext(UserContext);

	let subtotal = cartItems.reduce((acc, item) => {
		if (isNaN(item.price)) return acc;
		return acc + calcMemberPrice(item, userData) * item.quantity;
	}, 0);

	function removeItem(variantId) {
		setLocalCart((localCart) => {
			GTM.removeFromCart(localCart[variantId]);
			delete localCart[variantId];
			return { ...localCart };
		});
	}

	return (
		<Container className="container-sm ">
			{/* This only renders properly on the client, not on the server, seems like a bug with SSR */}
			{/* {typeof window !== "undefined" && ( */}
			<>
				{cartItems?.length === 0 && (
					<Row className="my-5">
						<Col className="d-flex justify-content-center align-items-center">
							<Title text="Your cart is empty" color={colors.darkBlue} />
						</Col>
					</Row>
				)}
				{cartItems?.length > 0 && (
					<>
						{/* Header Row */}
						<Row className="g-0 ">
							<ProductCol>Product</ProductCol>
							<CenteredCol xs={3} sm={3}>
								Quantity
							</CenteredCol>
							<CenteredCol xs={3} sm={2}>
								Price
							</CenteredCol>
							<CenteredCol xs={1} sm={2}>
								Remove
							</CenteredCol>
						</Row>
						{cartItems.map((item) => {
							const price = calcMemberPrice(item, userData); //user?.isMember ? item.price - item.price * 0.15 : item.price;
							return (
								<Row key={item.variantId} className=" py-3 cartItem g-0">
									{/* Product img and name/link */}
									<ProductCol>
										<Row className="w-100  g-0">
											<Col xs={12} lg={4}>
												{item.productMedia?.length > 0 && (
													<div className="productMedia">
														<Media width={100} data={item.productMedia[0]} />
													</div>
												)}
											</Col>
											<Col lg={true}>
												<Row>
													<Col xs={12}>
														{/* Product Title */}
														<Link href={`${item.productUrl}`} className="pt-1 hover:text-palette-dark">
															{item.title}
														</Link>
													</Col>
													<LineItemDetails
														label={"Unit Price"}
														value={<Price round={false} num={price} showFree={true} />}
													/>

													<LineItemDetails label={"Variant"} value={item.deliveryFormat} />

													{item.option && (
														<LineItemDetails label={"Option"} value={item.option} />
													)}
												</Row>
											</Col>
										</Row>
									</ProductCol>
									{/* Item Quantity */}
									<CenteredCol xs={3} sm={3}>
										<QuantityInput removeItem={removeItem} item={item} />
									</CenteredCol>
									{/* Item Price */}
									<CenteredCol xs={3} sm={2}>
										<Price
											round={false}
											showFree={true}
											num={calcMemberPrice(item, userData) * item.quantity}
										/>
									</CenteredCol>
									{/* Item Remove */}
									<CenteredCol xs={1} sm={2}>
										<span
											title={`Remove ${item.title}`}
											aria-label="delete-item"
											className="delete-icon"
											onClick={() => removeItem(item.variantId)}
										>
											<FontAwesomeIcon icon={faTimes} className="icon" />
										</span>
									</CenteredCol>
									<hr />
								</Row>
							);
						})}
					</>
				)}

				{cartItems?.length > 0 && (
					<Row className="justify-content-end bottom-row ">
						<Col xs={4}>
							<span className="">
								{`Subtotal: `}
								<Price round={false} showFree={false} num={subtotal} />
							</span>
						</Col>
					</Row>
				)}
			</>
			{/* )} */}

			<style jsx>{`
				.delete-icon {
					color: ${colors.red};
				}
				.productMedia {
					width: 100px;
				}

				hr {
					margin: 0px;
					padding: 0px;
					margin-top: 1em;
				}
			`}</style>
		</Container>
	);
}

function LineItemDetails(props) {
	return (
		<Col xs={12}>
			<Text
				color={colors.lightBrown}
				size="12px"
				marginBottom={0}
				text={
					<>
						{props.label}:&nbsp;
						<Text color={colors.dark} size="12px" text={props.value} weight={"bold"} marginBottom={0} />
					</>
				}
			/>
		</Col>
	);
}
